import { TemplateRef } from '@angular/core';
import { MaklerDocumentType, MaklerPolizzeDetails, VollmachtOption } from '@o30/entities';

const DOCUMENT_EXISTS = 'Dokument vorhanden';
const DOCUMENT_DOESNT_EXISTS = 'Kein Dokument vorhanden';

export type SimpleVollmachtStatus = 'exists' | 'uploaded' | 'not-uploaded';

export type SimpleVollmachtStatusConfig = {
  [key in SimpleVollmachtStatus]: {
    label: string;
    checkOk: boolean;
  };
};

export interface MaklerDocumentLayoutConfig {
  label: string;
  actionLabel: string;
  description: string;
  documentType: MaklerDocumentType;
  getStatusTextFunction: (details: MaklerPolizzeDetails) => string;
  getStatusTemplateRefFunction: (details: MaklerPolizzeDetails) => TemplateRef<void>;
}

export const SIMPLE_VOLLMACHT_STATUS_CONFIG: SimpleVollmachtStatusConfig = {
  'exists':       {
    label:   'Liegt bei NV auf',
    checkOk: true
  },
  'uploaded':     {
    label:   DOCUMENT_EXISTS,
    checkOk: true
  },
  'not-uploaded': {
    label:   DOCUMENT_DOESNT_EXISTS,
    checkOk: false
  }
};

/**
 * map vollmacht selection & document to simple status for the ui
 */
export function getSimpleVollmachtStatus(details: MaklerPolizzeDetails): SimpleVollmachtStatus {
  switch (details?.vollmachtOption) {
    case VollmachtOption.LIEGT_AUF:
      return 'exists';
    case VollmachtOption.ERZEUGEN_HOCHLADEN:
    case VollmachtOption.LIEGT_NICHT_AUF:
      return details?.vollmachtDokument || details?.vollmachtArchived ?
        'uploaded' : 'not-uploaded';
    default:
      return 'not-uploaded';
  }
}

export function maklerDocumentExists(details: MaklerPolizzeDetails, documentType: MaklerDocumentType): boolean {
  if (!details) {
    return false;
  }
  return !!details[documentType.toLowerCase() + 'Archived'] || !!details[documentType.toLowerCase() + 'Dokument'];
}

// ================= STATUS TEXT FUNCTION =====================

export function getVollmachtStatusText(details: MaklerPolizzeDetails): string {
  const simpleVollmachtStatus = getSimpleVollmachtStatus(details);
  return SIMPLE_VOLLMACHT_STATUS_CONFIG[simpleVollmachtStatus]?.label;
}

export function getDocumentStatusText(details: MaklerPolizzeDetails): string {
  const documentType = MaklerDocumentType.GENEHMIGUNG; // vollmacht is now handled differently
  const documentExists = maklerDocumentExists(details, documentType);
  if (documentExists) {
    return DOCUMENT_EXISTS;
  } else {
    return DOCUMENT_DOESNT_EXISTS;
  }
}
